import { render } from "./DashboardTooltip.vue?vue&type=template&id=5fbc2770&scoped=true"
import script from "./DashboardTooltip.vue?vue&type=script&lang=js"
export * from "./DashboardTooltip.vue?vue&type=script&lang=js"

import "./DashboardTooltip.vue?vue&type=style&index=0&id=5fbc2770&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbc2770"]])

export default __exports__